import { render } from "./ContactsNav.vue?vue&type=template&id=4e8ff16d&scoped=true"
import script from "./ContactsNav.vue?vue&type=script&lang=js"
export * from "./ContactsNav.vue?vue&type=script&lang=js"

import "./ContactsNav.vue?vue&type=style&index=0&id=4e8ff16d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e8ff16d"]])

export default __exports__